<script>
export default {
  props: ['filters', 'activeFilters', 'activeClass'],
  data() {
    return {
      active: '',
      disablePrograms: false,
      disableCourses: false,
    };
  },
  methods: {
    submitFilter(key, value, programOrCourse) {
      let isFacet = true;
      switch (programOrCourse) {
        case 'SearchProgram':
          this.disableCourses = !this.disableCourses;
          key = programOrCourse;
          value = this.disableCourses ? true : false;
          isFacet = false;
          break;
        case 'SearchCourse':
          this.disablePrograms = !this.disablePrograms;
          key = programOrCourse;
          value = this.disablePrograms ? true : false;
          isFacet = false;
          break;
      }
      isFacet && (value = this.trimValueForFacet(value));
      this.$emit('update-request', key, value, isFacet);
    },
    getDisabled(key, index) {
      return key == 'ProgramOrCourse'
        ? index == 0
          ? this.disablePrograms
          : this.disableCourses
        : false;
    },
    getProgramOrCourse(key, index) {
      return key == 'ProgramOrCourse'
        ? index == 0
          ? 'SearchProgram'
          : 'SearchCourse'
        : undefined;
    },
    isActive(key, value, index) {
      const isProgramOrCourse = this.getProgramOrCourse(key, index);
      return isProgramOrCourse
        ? this.active.includes(isProgramOrCourse)
        : this.active.includes(value);
    },
    trimValueForView(value) {
      value.includes('Höstterminen') &&
        (value = value.replace('Höstterminen', 'Hösten'));
      value.includes('Vårterminen') &&
        (value = value.replace('Vårterminen', 'Våren'));
      value.includes('Behörighetsgivande utbildning') &&
        (value = value.replace(
          'Behörighetsgivande utbildning',
          'Förutbildning'
        ));
      return value;
    },
    trimValueForFacet(value) {
      value.includes('Hösten') &&
        (value = value.replace('Hösten', 'Höstterminen'));
      value.includes('Våren') &&
        (value = value.replace('Våren', 'Vårterminen'));
      value.includes('Förutbildning') &&
        (value = value.replace(
          'Förutbildning',
          'Behörighetsgivande utbildning'
        ));
      return value;
    },
  },
  mounted() {
    if (this.activeFilters) {
      this.active = this.activeFilters;
    }
  },
  updated() {
    if (this.activeFilters) {
      const searchCourse = this.activeFilters.find((f) => f === 'SearchCourse');
      const searchProgram = this.activeFilters.find(
        (f) => f === 'SearchProgram'
      );
      this.disablePrograms = searchCourse ? true : false;
      this.disableCourses = searchProgram ? true : false;
      this.active = this.activeFilters;
    }
  },
};
</script>

<template>
  <div class="filter--container">
    <div v-for="(filter, index) in this.filters" class="filter--wrapper">
      <label v-if="filter.title">{{ filter.title }}</label>
      <div class="d-flex flex-row flex-wrap filter--list">
        <ul class="d-flex flex-wrap list-unstyled">
          <li v-for="(value, index) in filter.values" :key="index">
            <button
              type="button"
              :disabled="getDisabled(filter.key, index)"
              :class="[
                { selected: isActive(filter.key, value, index) },
                isActive(filter.key, value, index) ? activeClass : '',
              ]"
              class="button-small"
              @click="
                submitFilter(
                  filter.key,
                  value,
                  getProgramOrCourse(filter.key, index)
                )
              "
            >
              {{ trimValueForView(value) }}
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
